export default IconUsersMinus => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-users-minus" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M5 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
  <path d="M3 21v-2a4 4 0 0 1 4 -4h4c.948 0 1.818 .33 2.504 .88" />
  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  <path d="M16 19h6" />
</svg>`;